import React from 'react';
import MobileAppSection from './MobileAppSection';

const OurAppPage = () => (
  <div>
    <MobileAppSection />
  </div>
);

export default OurAppPage;
